import { NgModule } from '@angular/core';
import {
  ExportOptionsFormDirective
} from '@app/pcs/shared/export-options/pop-over-export-options/components/export-options-form.directive';
import {
  PopOverExportOptionsComponent
} from '@app/pcs/shared/export-options/pop-over-export-options/components/pop-over-export-options.component';
import { SharedModule } from '@app/shared/shared.module';

@NgModule({
  imports: [SharedModule],
  declarations: [
    PopOverExportOptionsComponent,
    ExportOptionsFormDirective
  ],
  exports: [
    PopOverExportOptionsComponent,
    ExportOptionsFormDirective
  ]
})
export class PopOverExportOptionsModule {

}
